import React, { useState } from 'react';
import { Link } from 'gatsby';
import Copyright from './copyright';
import Modal from '@codedrop/modal/esm/modal';
import Form from '@codedrop/form/esm/form-dynamic';
import setHTML from '@codedrop/utils/esm/utils';

let Graphic = () => /*#__PURE__*/React.createElement("div", null, "Logo");

const Footer = ({
  footer
}) => {
  const [modalState, setModalState] = useState(false);

  if (footer.logo) {
    Graphic = () => {
      const graphicFile = require("../images/".concat(footer.logo));

      return graphicFile.default();
    };
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "footer background--firework-left-right ".concat(footer.modifierClass)
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer__container grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid__col grid--6-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer__logo"
  }, /*#__PURE__*/React.createElement(Graphic, null)), /*#__PURE__*/React.createElement("div", {
    className: "heading--special heading--xxl"
  }, setHTML(footer.heading))), /*#__PURE__*/React.createElement("div", {
    className: "grid__col grid--6-col footer__main-menu-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid"
  }, footer.menu.map((column, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "grid__col grid--6-col footer__menu ".concat(column.modifierClass ? column.modifierClass : ''),
      key: "footer-menu-".concat(index)
    }, /*#__PURE__*/React.createElement("h5", null, column.title), /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("ul", null, column.items.map((item, itemIndex) => {
      if (item.external) {
        return /*#__PURE__*/React.createElement("li", {
          key: "footer-menu-column-".concat(itemIndex)
        }, /*#__PURE__*/React.createElement("a", {
          href: item.link,
          target: "_blank",
          rel: "noopener noreferrer"
        }, item.linkText));
      } else {
        return /*#__PURE__*/React.createElement("li", {
          key: "footer-menu-column-".concat(itemIndex)
        }, /*#__PURE__*/React.createElement(Link, {
          to: item.link
        }, item.linkText));
      }
    }))));
  })))), /*#__PURE__*/React.createElement(Copyright, {
    copyright: footer.copyright
  }));
};

Footer.displayName = 'Footer';
export default Footer;